import React, { createContext, useContext, useState } from "react";
import ContactModal from "../components/ContactModal";

const ContactModalContext = createContext(null);

export const ContactModalProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openContactModal = () => setOpen(true);
  const closeContactModal = () => setOpen(false);

  return (
    <ContactModalContext.Provider value={{ openContactModal }}>
      {children}
      <ContactModal open={open} onClose={closeContactModal} />
    </ContactModalContext.Provider>
  );
};

export const useContactModal = () => {
  const ctx = useContext(ContactModalContext);
  if (!ctx) throw new Error("useContactModal must be used within ContactModalProvider");
  return ctx;
};
